// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"32019e1e","484":"286ae595"}[chunkId] + ".chunk.js";
};